<div class="page-content-wrapper">
  <div class="card shadow border-1 rounded-3">
    <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
      <p class="text-s fw-bold">Customers</p>
    </div>
    <div class="card-body">
      <CustomTable
        :columns="columns"
        :fetchData="getCustomers"
        :hasActions="true"
        tableKey="customers"
      >
        <template v-slot:cell-name_email="{ row }">
          {{ row.full_name || (row.first_name + ' ' + row.last_name) }}
          <p class="text-xxs fw-bold">{{ row.email }}</p>
        </template>
        <template v-slot:cell-date_joined="{ row }">
          {{ formatDate(row.date_joined) }}
        </template>
        <template v-slot:actions="{ row }">
          <button class="btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow me-2"
                @click="viewCustomer(row.id)">View</button>
          <button
            :class="row.is_active ? 'btn btn-danger btn-sm text-xxs fw-bold rounded-3 shadow' : 'btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow'"
            @click="toggleUserStatus(row)"
          >
            {{ row.is_active ? 'Deactivate' : 'Activate' }}
          </button>
        </template>
      </CustomTable>
    </div>
  </div>
</div>